import { ObjectModel } from 'objectmodel';

const Task = new ObjectModel({
  data: {
    type: ['name', 'url', 'push-app', undefined, null],
    url: [String],
    name: [String],
    csId: [String],
    pixel: [String],
    action: [String],
    detail: [Object],
  },
  name: String,
  origin: [String],
  getFilterResults: Boolean
});

export { Task };
